import { observable, autorun } from "mobx";
import { Observer } from "mobx-react";
import React from "react";

class Persist {
  make = async (value, localStorageItem) => {
    if(value == undefined) return;
    let stringValue = typeof value !== "object" ? String(value) : JSON.stringify(value);
    await localStorage.setItem(localStorageItem, stringValue);
  }

  persist = async (localStorageItem, type) => {
    let value = await localStorage.getItem(localStorageItem);
    if(value == null) return undefined;
    if(type == "string") return value;
    if(type == "number") return Number(value);
    if(type == "object" || type == "array") {
      try {
        let parsed = JSON.parse(value);
        return parsed;
      } catch(err) {
        return undefined;
      }
    }
    if(type == "boolean") return value === "true" ? true : false;
  }
}

const makePersit = new Persist();

const passDown = storeName => children => (
  <Observer
    inject={ stores => ({ [storeName]: stores[storeName] })}
    render={props => children}
  />
)

export default {
  makePersit, passDown
}


// WEBPACK FOOTER //
// ./src/utils/MobXHelper.js